<template>
    <div class="ui-card-client">
        <ui-overlay-load v-if="load" />

        <div class="ui-no-content" v-if="!client">
            <ui-button design="md grey" @click="add"><i class="fal fa-plus"></i></ui-button>
            <div class="title">Nenhum cliente selecionado.</div>
        </div>

        <div class="ui-card" v-else>
            <div class="ui-card-header">
                <ui-button design="close" @click="hide"><i class="fal fa-times"></i></ui-button>
            </div>

            <div class="ui-card-content">
                <ui-tag-indicator :color="idleColor" :text="String(deal.id)" :radius="3" :textSize="11" v-if="deal.id" />

                <ui-badge :initials="client.name" color="#606d84" design="lg" :radius="60" v-if="client.name" />
 
                <div class="client-name" v-if="client.name">{{ client.name }}</div>
                <div class="client-info" v-if="client.cpf">CPF: {{ client.cpf | documentBr }}</div>

                <ui-tag-line v-if="deal.stage" :text="deal.stage.name || '-'" :color="idleColor" :textSize="11" />
            </div>

            <div class="ui-card-footer">
                <ui-tag-icon v-if="mobileComputed" :icon-size="16" :text-size="11" :border="0" :text="String(mobileComputed)" icon="fab fa-whatsapp" />
                <ui-tag-icon v-if="client.email"  :icon-size="16" :text-size="11" :border="0" :text="client.email" icon="fal fa-envelope-open-text" />
            </div>
        </div>
    </div>
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"
    import { uiOverlayLoad, uiBadge } from '@/components/ui'
    import { uiTagLine, uiTagIndicator, uiTagIcon } from '@/components/ui/tags'
    import { maskIntl } from '@/mixins'

    import { idle } from '@/services/axios'
    import { idleHooks } from '@/services/hooks'

    import { documentBr } from "@/filters"

    export default {
        components: {
            uiButton,
            uiOverlayLoad,
            uiBadge,
            uiTagLine,
            uiTagIcon,
            uiTagIndicator,
        },

        filters: { 
            documentBr
        },

        mixins: [maskIntl],

        props: {
            client: {
                type: Object,
                required: false,
                default () {
                    return {}
                }
            },

            deal: {
                type: Object,
                required: false,
                default () {
                    return {}
                }
            },

            load: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                unsubscribe: null,
                idleRules: []
            }
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (mutation.type === 'simulation/SET_CUSTOMER_DEAL' &&
                    mutation.payload &&
                    mutation.payload.funnel_stage_id) {
                    idle.getByStage(mutation.payload.funnel_stage_id)
                        .then(response => {
                            this.idleRules = [...response.data.data]
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            console.log(error)
                        })
                }
            })
        },

        beforeDestroy() {
			this.unsubscribe()
        },

        computed: {
            mobileComputed() {
                if (this.client.phone || this.client.mobile)
                    return this.client.mobile ? this.formatPhoneNew(this.client.country_code_mobile ,this.client.mobile) : this.formatPhoneNew(this.client.country_code_phone ,this.client.phone)
                    
                else return null
            },
            /**
             * Retorna a cor da ociosidade de acordo com as regras de ociosidade
             */
            idleColor() {
                return idleHooks.handleColor(
                    this.deal.moved_at || this.deal.updated_at,
                    this.deal.funnel_stage_id,
                    this.deal.funnel_stage_status_id,
                    this.idleRules
                )
            }
        },

        methods: {
            add() {
                this.$emit('add')
            },

            hide() {
                this.$emit('hide')
            },

            edit() {
                this.$emit('edit')
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>